export class Controller {

    /** @ngInject */
    constructor(AuthenticationSharedService) {
        this.AuthenticationSharedService = AuthenticationSharedService;
    }

    $onInit() {
        this.isSsoLoading = true;
        this.AuthenticationSharedService.login({})
            .finally(() => this.isSsoLoading = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/client-sso-saaspass-login/client-sso-saaspass-login.controller.js